import { getMenuRequest, getMenuSuccess, getMenuFailure } from './commonSlice'
import { strapiFetch } from 'lib/strapi'

export const getMenuAction = ({
  type,
  slug,
  locale = 'en',
}: {
  type: string
  slug?: string
  locale?: string
}) => {
  return async (dispatch: any) => {
    try {
      dispatch(getMenuRequest({ type }))

      const { data }: any = await strapiFetch(
        `/api/main-menu?populate[items][populate]=page`
      )

      dispatch(
        getMenuSuccess({
          items: data.items,
          type,
        })
      )
    } catch (err: any) {
      console.log(err)
      dispatch(
        getMenuFailure({
          errorMessage: err?.message || 'Unable to load navigation menu.',
          type,
        })
      )
    }
  }
}
